$(() => {
    $("#abo_subscribe").on("click", function() {
        $("#abo_subscribe").prop("disabled", true).addClass("disabled").hide();
        $("#abo_sec_confirm").show();
        $("#abo_sec").slideDown("slow");
    });
    
    $("#abo_sec_confirm").on("click", function() {
        if(!$("#abo_sec_confirm").hasClass("disabled")) {
            $("#abo_messages").empty();

            $("#abo_sec_confirm").prop("disabled", true).addClass("disabled");
    
            $.ajax({
                type: "POST",
                url: "/abo/subscribe",
                dataType: 'json',
                data: {
                    "email": $('#abo_mail').val(),
                    "params": $('#abo_params').val(),
                    "sec_confirm": 1,
                    "sec_txt": $("#abo_sec").text().replace(/\s{2,}/g, " ").replace(/[\r\n\t]/g, "").trim()
                },
                headers: { "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content") }
            }).always(function() {
                $("#abo_msg").empty();
            }).done(function(response, textStatus) {
                if (response.error) {
                    $("#abo_msg")
                        .append('<div class="alert alert-danger alert-dismissible fade show" role="alert">' + response.msg + '<button type="button" class="close" data-dismiss="alert" aria-label="Verwerfen"><span aria-hidden="true">&times;</span></button></div>')
                        .slideDown("slow");
                    $("#abo_sec_confirm").prop("disabled", false).removeClass("disabled");
                } else {
                    $("#abo_form").hide();
                    $("#abo_success").show();

                    //Analytics Tracking für Jobradar
                    if (typeof ga !== 'undefined') {
                        ga('send', 'event', 'abo', 'subscribe', response.abo_id);
                    }
                }
            }).fail(function(response, textStatus) {
                $("#abo_msg")
                    .append('<div class="alert alert-danger alert-dismissible fade show" role="alert">Bei der Verarbeitung ist etwas schief gelaufen.<button type="button" class="close" data-dismiss="alert" aria-label="Verwerfen"><span aria-hidden="true">&times;</span></button></div>')
                    .slideDown("slow");
                $("#abo_sec_confirm").prop("disabled", false).removeClass("disabled");
            });
        }
    });

    $("#abo_unsubscribe").on("click", function(){
        $.ajax({
            type: "POST",
            url: "/abo/unsubscribe_now",
            dataType: "json",
            headers: { "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content") },            
            data: { abo: $("#abo_unsubscribe").data("id"), unsubscribe: "yes" }
        }).done((response) => {
            $("#del_request").addClass("hidden");
            $("#del_confirm").removeClass("hidden");

            if (typeof ga !== 'undefined') {
                ga('send', 'event', 'abo', 'unsubscribe', $("#abo_unsubscribe").data("id"));
            }
        });
    });
    
    if (typeof ga !== 'undefined' && $("#abo_confirm").length) {
        ga('send', 'event', 'abo', 'confirm', $("#abo_confirm").data("id"));
    }
});


// WEBPACK FOOTER //
// ./resources/js/abo.js